var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Head'),_c('Our'),_c('a',{staticClass:"go-top",attrs:{"href":"#"}},[_c('v-icon',{attrs:{"name":"arrow-up"}})],1),_c('Experience')],1)}
var staticRenderFns = []

export { render, staticRenderFns }